export const t_global_breakpoint_height_xl = {
  "name": "--pf-t--global--breakpoint--height--xl",
  "value": "60rem",
  "var": "var(--pf-t--global--breakpoint--height--xl)"
};
export default t_global_breakpoint_height_xl;